export default __webpack_public_path__ + "static/media/baner7.3e15585b.png";